import React, { Fragment } from "react";
import BlackLogo from "./BlackLogo";

const ApplicationRemoved = ({ clearJobs }) => {
  return (
    <Fragment>
      <div className="messages-overlay">
        <div className="request-box-light">
          <i
            className="fas fa-times fa-3x message-x-dark"
            onClick={() => {
              clearJobs();
            }}
          ></i>
          <div className="flex-center">
            <div className="index-logo-alt">
              <BlackLogo />
            </div>
          </div>
          <div className="user-request-text-light">
            Your pending application has been removed.
          </div>
          <div className="flex-center">
            <button
              className="user-request-button background-dark-black white"
              onClick={() => {
                clearJobs();
              }}
            >
              <i className="fas fa-times fa-sm mr-5"></i>
              Close
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ApplicationRemoved;
